import React, { Component } from 'react'
import { connect } from 'react-redux'
import AppStore from 'store/AppStore'
import SieauAction from '../../../components/sieau/SieauAction'
import DtoPiezometerLight from '../../../piezometry/dto/DtoPiezometerLight'
import { arrayOf, getMapStateToProps, getPropTypes } from '../../../utils/StoreUtils'
import SimpleKeyFigurePanel from '../../../components/keyFigures/SimpleKeyFigurePanel'

const propsToFetch = {
    userKeyfigures: true,
    qualityKeyfigures: true,

    qualitometers: false,
    hydrometricStations: false,
}

class DashboardKeyFiguresPanel extends Component {
    componentDidMount() {
        AppStore.dispatch(SieauAction.fetch(propsToFetch))
    }

    render() {
        const {
            userKeyfigures,
            qualityKeyfigures,
            piezometers,
            qualitometers,
            hydrometricStations,
        } = this.props

        if (userKeyfigures.length === 0 || qualityKeyfigures.length === 0) {
            return undefined
        }

        const data = [
            userKeyfigures.find(k => k.title === 'users'),
            {
                title: 'piezometers',
                value: piezometers.length,
            },
            {
                title: 'qualitometers',
                value: qualitometers.length,
            },
            {
                title: 'hydrometricStations',
                value: hydrometricStations.length,
            },
            qualityKeyfigures.find(k => k.title === 'operations'),
            qualityKeyfigures.find(k => k.title === 'analysis'),
        ]
        return <SimpleKeyFigurePanel data={ data }/>
    }
}

DashboardKeyFiguresPanel.propTypes = getPropTypes(propsToFetch, {
    piezometers: arrayOf(DtoPiezometerLight),
})

const mapStateToProps = store => getMapStateToProps(propsToFetch, {
    piezometers: store.PiezometryReducer.piezometersLight,
})

export default connect(mapStateToProps)(DashboardKeyFiguresPanel)